import script from "./BookUserData.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookUserData.vue?vue&type=script&setup=true&lang=ts"

import "./BookUserData.vue?vue&type=style&index=0&id=17d884ce&lang=css"

const __exports__ = script;

export default __exports__